export const raceAndEthnicity = [
  { label: 'American Indian or Alaska Native', value: 'American Indian or Alaska Native' },
  { label: 'Hispanic or Latino', value: 'Hispanic or Latino' },
  { label: 'White', value: 'White' },
  { label: 'Asian', value: 'Asian' },
  { label: 'Middle Eastern or North African', value: 'Middle Eastern or North African' },
  { label: 'Black or African American', value: 'Black or African American' },
  { label: 'Native Hawaiian or Other Pacific Islander', value: 'Native Hawaiian or Other Pacific Islander' },
  { label: 'Not Listed', value: 'Not Listed' },
];
